import { Component, output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { InputText } from '@openng/optimus-ui/inputtext';
import { ButtonDirective } from '@openng/optimus-ui/button';

@Component({
  selector: 'app-op-log-mobile-filter',
  templateUrl: './op-log-mobile-filter.component.html',
  styleUrls: ['./op-log-mobile-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslateDirective,
    FormsModule,
    InputText,
    ButtonDirective,
    TranslatePipe,
  ],
})
export class OpLogMobileFilterComponent {
  readonly mobileFilterEvent = output<any>();

  logId: string | null = null;
  facilityName: string | null = null;
  statusName: string | null = null;

  mobileFilter() {
    this.mobileFilterEvent.emit({
      facilityUID: this.logId,
      facilityName: this.facilityName,
      statusName: this.statusName,
    });
  }

  clear() {
    this.logId = null;
    this.facilityName = null;
    this.statusName = null;
    this.mobileFilter();
  }
}
